import { render, staticRenderFns } from "./ListCertifications.vue?vue&type=template&id=99ff6326"
import script from "./ListCertifications.vue?vue&type=script&lang=js"
export * from "./ListCertifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports